import { FormControl, FormGroup, FormRecord } from '@angular/forms';
import { RessourcesEnfantModel } from '../../ressources-enfant/models/ressources-enfant.model';
import { RubriqueMontantForm } from '@cnaf.usagers.appli/cnaf-commons-dral';


export class EnfantModel {
    id: number;
    moins21ans: boolean;
    revenue12DernierMois: boolean;
    informationRessources: boolean;
    ressources: RessourcesEnfantModel;
    codeSituationPro : string;

    constructor(id, moins21ans, revenue12DernierMois, informationRessources) {
        this.id = id;
        this.moins21ans = moins21ans;
        this.revenue12DernierMois = revenue12DernierMois;
        this.informationRessources = informationRessources;
    }
}

export class EnfantForm {
    questionAgeMax? : FormControl<string>;
    questionRevenuDernierMois? : FormControl<string>;
    ressourcesEnfant? : FormRecord<FormGroup<RubriqueMontantForm>>;
    questionSitPro? : FormControl<string>;
}
